import React, { Component } from "react";
import PropTypes from "prop-types";

export class Loader extends Component {	

	render() {
		const { color, size } = this.props;
		
		return (
			<div className={`tv-loader preloader-wrapper ${size} active`}>
		    <div className={`spinner-layer ${color ? `-${color}` : ""}`}>
		      <div className="circle-clipper left">
		        <div className="circle"></div>
		      </div><div className="gap-patch">
		        <div className="circle"></div>
		      </div><div className="circle-clipper right">
		        <div className="circle"></div>
		      </div>
		    </div>
		  </div>
		);
	}
}

Loader.propTypes = {
	size: PropTypes.string,
	color: PropTypes.string
};

Loader.defaultProps = {
	size: "",
	color: ""
};


// WEBPACK FOOTER //
// src/atoms/lib/Loader.js